const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2z\"/><path fill=\"currentColor\" d=\"M13 16h-2v2h2zm0-6h-2v5h2z\"/>"
};
export default data;
